import styled from "styled-components";
import { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { StyledPageHeader } from "../../components/YachtClub/YachtClubRegistration/YachtClubRegistrationHeader";
import BoxBlueWithHeader from "../../components/YachtClub/ViewDetails/BoxBlueWithHeader";
import {
  Colors,
  PAYMENT_MODES,
  PAYMENT_MODES_POPUP,
} from "../../config/Constants";
import VisitDetails from "../../components/YachtClub/ViewDetails/VisitDetails";
import OwnersDetails from "../../components/YachtClub/ViewDetails/OwnersDetails";
import VesselDetails from "../../components/YachtClub/ViewDetails/VesselDetails";
import VesselDocument from "../../components/YachtClub/ViewDetails/VesselDocument";
import Button from "../../components/Button";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import RejectModal from "../../components/Modal/RejectModal";
import BerthRentalRejection from "../../components/YachtClub/ViewDetails/BerthRentalRejection";
import {
  getYatchRegistrationDetails,
  putYachtApproveRejectData,
  putCashChequePayment,
} from "../../services/yachtClubService";
import PaymentDetailsModal from "../../components/YachtClub/ViewDetails/PaymentDetailsModal";
import { amountValidation, chequeValidation, Validation } from "./validation";
import BerthPayment from "../../components/YachtClub/ViewDetails/BerthPayment";
import { useLoadContext } from "../../contexts/LoadContext";
import { toast } from "react-toastify";
import { ToastMessage } from "../../components/ToastMessage";
import ErrorSuccessModal from "../../components/Modal/ErrorSuccessModal";
import { getFormattedPaymentPayloadForApproval, getFormattedDuration } from "../../helper";
import { useYachtContext } from "../../contexts/YachtContext";
import AdditionalService from "../../components/YachtClub/ViewDetails/AdditionalService";

const YachtClubViewDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const { setLoader } = useLoadContext();
  const [approveConfirmationModal, setApproveConfirmationModal] =
    useState(false);
  const [rejectConfirmationModal, setRejectConfirmationModal] = useState(false);
  const [paymentDetailsModal, setPaymentDetailsModal] = useState(false);
  const [commentError, setCommentError] = useState("");
  const [comment, setComment] = useState("");
  const [details, setDetails] = useState({
    name: "",
    visitDate: "",
    visiTime: "",
    package: "",
    paymentMode: "",
    paymentStatus: "",
    workAddress: "",
    residentialAddress: "",
    passportOrqID: "",
    email: "",
    phone: "",
    title: "",
    vesselName: "",
    vesselRegNo: "",
    vesselBrand: "",
    builtYear: "",
    vesselLoa: "",
    beam: "",
    draft: "",
    rejectNotes: "",
    payNote: "",
    price: "",
    parkingSpace: "",
    registrationUrl: "",
    passportOrqIDUrl: "",
    imageUrl: "",
    insuranceUrl: "",
    type: "",
    additionalFacility: [],
  });
  const [paymentData, setPaymentData] = useState({
    paymentMode: "",
    chequeNumber: "",
    cashAmount: "",
  });
  const [paymentDataError, setPaymentDataError] = useState({
    paymentMode: "",
  });
  const navigate = useNavigate();
  const [approvedOrRejected, setApprovedOrRejected] = useState("");
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    heading: "",
    subHeading: "",
  });
  const { berthID } = useYachtContext();

  const [enteredBerthPayment, setEnteredBerthPayment] = useState("");
  const [paymentInputError, setPaymentInputError] = useState("");
  const [paymentPopupInputError, setPaymentPopupInputError] = useState("");
  const [berthPaymentDetailsModal, setBerthPaymentDetailsModal] =
    useState(false);

  const handleBerthPopupClose = () => {
    setBerthPaymentDetailsModal(false);
    setPaymentData({
      paymentMode: "",
      chequeNumber: "",
      cashAmount: "",
    });
    setPaymentDataError({
      paymentMode: "",
    });
  };

  const handlePaymentReceivedClick = () => {
    if (paymentData.paymentMode !== "") {
      if (paymentData.paymentMode === "cheque")
        handlePopupPaymentSubmit("cheque", paymentData.chequeNumber);
      if (paymentData.paymentMode === "cash")
        handlePopupPaymentSubmit("cash", paymentData.cashAmount);
    } else {
      setPaymentDataError({
        paymentMode: "Please select payment mode",
      });
    }
  };

  const handlePaymentSubmit = () => {
    if (details.paymentMode === "cheque") {
      if (!chequeValidation(enteredBerthPayment, setPaymentInputError)) {
        handlePutPaymentSubmit({
          payNote: enteredBerthPayment,
        });
      }
    }
    if (details.paymentMode === "cash") {
      if (!amountValidation(enteredBerthPayment, setPaymentInputError)) {
        handlePutPaymentSubmit({
          payNote: enteredBerthPayment,
        });
      }
    }
  };

  const handlePopupPaymentSubmit = (mode: string, data: string) => {
    if (mode === "cheque") {
      if (!chequeValidation(data, setPaymentPopupInputError)) {
        handlePutPaymentSubmit({
          paymentMode: "cheque",
          payNote: data,
        });
      }
    }
    if (mode === "cash") {
      if (!amountValidation(data, setPaymentPopupInputError)) {
        handlePutPaymentSubmit({
          paymentMode: "cash",
          payNote: data,
        });
      }
    }
  };

  const handlePutPaymentSubmit = async (
    data:
      | { payNote: string }
      | {
          paymentMode: string;
          payNote: string;
        }
  ) => {
    setLoader(true);
    try {
      let res = await putCashChequePayment(id, data);
      if (res.status === 200) {
        fetchYatchData();
        setBerthPaymentDetailsModal(false);
      }
    } catch (error: any) {
      setLoader(false);
      setBerthPaymentDetailsModal(false);
      if (navigator.onLine) {
        setOpenErrorModal(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
  };

  const handlePaymentFieldsChange = (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    let formData = { ...paymentData };
    //@ts-ignore
    formData[event.target.name] = event.target.value;
    setPaymentDataError({
      paymentMode: "",
    });
    setPaymentPopupInputError("");
    setPaymentData(formData);
  };

  const handleContinueClick = () => {
    if (
      !Validation(paymentData, setPaymentDataError, setPaymentPopupInputError)
    ) {
      setPaymentDataError({ paymentMode: "" });
      setPaymentDetailsModal(false);
      setApproveConfirmationModal(true);
    }
  };

  const handleCommentChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setComment(event.target.value);
    setCommentError("");
  };

  const handleError = (error: any) => {
    if (navigator.onLine) {
      setOpenErrorModal(true);
      setErrorMessage({
        heading: "Something went wrong.",
        subHeading: error.message,
      });
    } else {
      toast.error(
        <ToastMessage
          message="You're offline now"
          subMessage="Oops! Internet is disconnected."
        />,
        {
          hideProgressBar: true,
        }
      );
    }
  };

  const handleApprove = () => {
    navigate("/admin/parking-layout", { state: { id: id } });
  };

  const handleApproveCall = async () => {
    setLoader(true);
    try {
      const response = await putYachtApproveRejectData(
        getFormattedPaymentPayloadForApproval(paymentData, berthID),
        id
      );
      if (response.data.code === 201) {
        setLoader(false);
        setPaymentData({
          paymentMode: "",
          chequeNumber: "",
          cashAmount: "",
        });
        setApproveConfirmationModal(false);
        navigate("/admin/yacht-club");
      }
    } catch (error: any) {
      setLoader(false);
      setApproveConfirmationModal(false);
      setPaymentDetailsModal(false);
      handleError(error);
    }
  };

  const handleReject = () => {
    setRejectConfirmationModal(true);
  };

  const handleRejectCall = async () => {
    if (comment === "") {
      setCommentError("Please enter comment.");
    } else {
      handleRejectModalClose();
      setLoader(true);
      let putPayload = {
        approved: 0,
        rejectNotes: comment,
      };
      try {
        let { data } = await putYachtApproveRejectData(putPayload, id);
        if (data.code === 201) {
          setLoader(false);
          navigate("/admin/yacht-club");
        }
      } catch (error: any) {
        setLoader(false);
        handleError(error);
      }
    }
  };

  const handleRejectModalClose = () => {
    setRejectConfirmationModal(false);
    setCommentError("");
    setComment("");
  };

  const handleCloseClick = () => {
    setPaymentData({
      paymentMode: "",
      chequeNumber: "",
      cashAmount: "",
    });
    setPaymentDetailsModal(false);
    navigate(location.pathname, {});
  };

  useEffect(() => {
    if (id) {
      fetchYatchData();
    }
    if (location.state) {
      setPaymentDetailsModal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchYatchData = async () => {
    let { data } = await getYatchRegistrationDetails(id);
    setDetails(data?.data);
    getHistoryOrRegistration(data.data.status);
    setLoader(false);
  };

  const getHistoryOrRegistration = (data: string) => {
    switch (data) {
      case "approved":
        setApprovedOrRejected("approved");
        break;
      case "rejected":
        setApprovedOrRejected("rejected");
        break;
      default:
        setApprovedOrRejected("processing");
        break;
    }
  };

  console.log('details', details);

  return (
    <>
      <HeaderWrapper>
        <HeaderName>
          <StyledPageHeader>Yacht Registration</StyledPageHeader>
          {/* <StyledName>- {details?.name}</StyledName> */}
        </HeaderName>
        <BackButtonWrapper>
          <Button
            label="Back"
            isRounded={true}
            onClick={() => navigate("/admin/yacht-club")}
          />
        </BackButtonWrapper>
      </HeaderWrapper>
      <BoxBlueWithHeader label={"Visit Details"}>
        <VisitDetails
          visitDate={details?.visitDate}
          visitTime={details?.visiTime}
          userPackage={details?.package}
          modeOfPayment={details?.paymentMode}
        />
      </BoxBlueWithHeader>

      <br />

      <BoxBlueWithHeader label={"Owner's Details"}>
        <OwnersDetails
          ownerName={details?.name}
          mobileNumber={details?.phone}
          email={details?.email}
          passport={details?.passportOrqID}
          homeAddress={details?.residentialAddress}
          workAddress={details?.workAddress}
          lrOrCap={details?.title}
        />
      </BoxBlueWithHeader>

      <br />

      <BoxBlueWithHeader label="Vessel Details">
        <VesselDetails
          vesselName={details?.vesselName}
          registrationNumber={details?.vesselRegNo}
          brandBuilder={details?.vesselBrand}
          yearBuilt={details?.builtYear}
          loaM={details?.vesselLoa}
          beamM={details?.beam}
          draftM={details?.draft}
        />
      </BoxBlueWithHeader>

      <br />

      <BoxBlueWithHeader label="Vessel Document">
        <VesselDocument
          idCard={`${details?.type} copy`}
          vesselPicture="Yacht picture"
          vesselRegistration="Registration copy"
          vesselInsurance="Insurance copy"
          idSrc={details?.passportOrqIDUrl}
          vesselPictureSrc={details?.imageUrl}
          vesselRegistrationSrc={details?.registrationUrl}
          vesselInsuranceSrc={details?.insuranceUrl}
        />
      </BoxBlueWithHeader>

      {details.additionalFacility?.length > 0 && (
        <>
          <br />
          <BoxBlueWithHeader label="Additional Services">
            <AdditionalService
              additionalFacility={details.additionalFacility}
            />
          </BoxBlueWithHeader>
        </>
      )}

      {approvedOrRejected === "rejected" && (
        <>
          <br />
          <BoxBlueWithHeader label="Reason for Berth Rental Rejection">
            <BerthRentalRejection rejectionReason={details.rejectNotes} />
          </BoxBlueWithHeader>
        </>
      )}

      {approvedOrRejected === "approved" && (
        <>
          <br />
          <BoxBlueWithHeader label="Berth Payment">
            <BerthPayment
              paymentStatus={details.paymentStatus}
              paymentMode={details.paymentMode}
              parkingSpace={details.parkingSpace}
              chequeNumber={details.payNote}
              transactionAmount={details.payNote}
              enteredBerthPayment={enteredBerthPayment}
              setEnteredBerthPayment={setEnteredBerthPayment}
              paymentInputError={paymentInputError}
              setPaymentInputError={setPaymentInputError}
              handlePaymentSubmit={handlePaymentSubmit}
              setBerthPaymentDetailsModal={setBerthPaymentDetailsModal}
            />
          </BoxBlueWithHeader>
        </>
      )}

      {approvedOrRejected === "processing" && (
        <ActionRow>
          <ButtonWrapper>
            <Button
              variant="filled"
              label="Approve"
              width="155px"
              color={Colors.appleGreen}
              onClick={handleApprove}
            ></Button>
            <Button
              variant="filled"
              label="Reject"
              width="155px"
              color={Colors.red}
              onClick={handleReject}
            ></Button>
          </ButtonWrapper>
        </ActionRow>
      )}

      {paymentDetailsModal && (
        <PaymentDetailsModal
          setOpenOrClose={() => {
            setPaymentDetailsModal(!paymentDetailsModal);
            navigate(location.pathname, {});
          }}
          handleCloseClick={handleCloseClick}
          paymentModes={PAYMENT_MODES}
          paymentData={paymentData}
          paymentDataError={paymentDataError}
          handleChange={handlePaymentFieldsChange}
          handleContinueClick={handleContinueClick}
          paymentInputFieldError={paymentPopupInputError}
          isButtonLabelChange={true}
        />
      )}

      {approveConfirmationModal && (
        <ConfirmModal
          heading="Confirm Renting Berth"
          subHeading={`Are you sure you want to approve ${details?.name}'s ${details.vesselName} Yacht with ${location.state.selectedSpot} Parking for a ${getFormattedDuration(details.package)}?`}
          button1Label="Cancel"
          button2Label="Yes"
          button1Submit={() => {
            setApproveConfirmationModal(false);
            setPaymentData({
              paymentMode: "",
              chequeNumber: "",
              cashAmount: "",
            });
            navigate(location.pathname, {});
          }}
          button2Submit={handleApproveCall}
          setOpenOrClose={() => {
            setApproveConfirmationModal(!approveConfirmationModal);
            navigate(location.pathname, {});
          }}
        />
      )}

      {rejectConfirmationModal && (
        <RejectModal
          setOpenOrClose={handleRejectModalClose}
          onRejectCall={handleRejectCall}
          handleChange={handleCommentChange}
          error={commentError}
          headerTitle="Reject Renting Berth"
          placeholderText="Add Comment"
          labelText="Comment"
          textAreaValue={comment}
          buttonLabel="Submit"
        />
      )}

      {openErrorModal && (
        <ErrorSuccessModal
          variant="error"
          heading={errorMessage.heading}
          subHeading={errorMessage.subHeading}
          buttonLabel="Ok"
          setOpenOrClose={setOpenErrorModal}
          onSubmit={() => setOpenErrorModal(false)}
        />
      )}
      {berthPaymentDetailsModal && (
        <PaymentDetailsModal
          setOpenOrClose={handleBerthPopupClose}
          handleCloseClick={handleBerthPopupClose}
          paymentModes={PAYMENT_MODES_POPUP}
          paymentData={paymentData}
          paymentDataError={paymentDataError}
          handleChange={handlePaymentFieldsChange}
          handleContinueClick={handlePaymentReceivedClick}
          modalHeader="Berth Payment"
          isRequiredInputfield={true}
          buttonLabel="Payment Received"
          paymentInputFieldError={paymentPopupInputError}
        />
      )}
    </>
  );
};

export default YachtClubViewDetails;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const BackButtonWrapper = styled.div`
  width: 120px;
`;

export const HeaderName = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-bottom: 2.5rem;
  @media only screen and (max-width: 768px) {
    padding: 0;
  }
`;

// const StyledName = styled.div`
//   font-family: "Poppins-book";
//   font-size: 1.25rem;
//   @media only screen and (max-width: 768px) {
//     padding: 1.25rem;
//   }
// `;

export const BoxTab = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 0.5rem;
  grid-row-gap: 2.5rem;
  padding: 1.25rem 0rem;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 850px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

export const BoxTabEach = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 14.5rem;
  width: -webkit-fill-available;
  margin: 0.5rem;
  margin-left: 0;
`;

export const TabHeader = styled.div`
  font-family: "Poppins-medium";
  font-size: 0.875rem;
  color: ${Colors.dustyGrayApprox};
`;

export const TabSub = styled.div`
  font-family: "Poppins-medium";
  font-size: 0.875rem;
  color: ${Colors.secondaryBlack};
`;

export const ActionRow = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 2rem;
  @media only screen and (max-width: 768px) {
    margin-top: 0;
  }
`;

export const ButtonWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.5rem;
    margin-top: 2rem;
    justify-content: center;
  }
`;
